export const COUNSELOR_CALL_CTA_1_CONSTANTS = {
  COUNSELOR_CALL_CTA_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Talk to our academic counsellor today!",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Heading",
      required: false,
      defaultValue: "Talk to our academic counsellor today!",
    },
    {
      fieldName: "title_text_color",
      label: "Title color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#F4F4F4",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F4F4F4",
      required: false,
      defaultValue: "#F4F4F4",
    },
    {
      fieldName: "phone_placeholder",
      label: "Phone input placeholder",
      value: "Enter your phone number",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Placeholder text",
      required: false,
      defaultValue: "Enter your phone number",
    },
    {
      fieldName: "pill_background_color",
      label: "Pill background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "pill_border_color",
      label: "Pill border",
      value: "#E5E5E5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E5E5E5",
      required: false,
      defaultValue: "#E5E5E5",
    },
    {
      fieldName: "button_label",
      label: "Button label",
      value: "Call Counsellor",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Call Counsellor",
      required: false,
      defaultValue: "Call Counsellor",
    },
    {
      fieldName: "button_background_color",
      label: "Button background",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#BE2330",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_text_color",
      label: "Button text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "counselor_tel",
      label: "Counselor phone (tel link)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "+9198XXXXXXXX or 098XXXXXXXX",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "subtitle",
      label: "Subtitle",
      value: "Know the right career fit for you",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Subtitle under pill",
      required: false,
      defaultValue: "Know the right career fit for you",
    },
    {
      fieldName: "subtitle_text_color",
      label: "Subtitle color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],
};
